import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatRiskAssessment',
  pure: false
})
export class FormatRiskAssessmentPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Replace **text** with <h2>text</h2>, *text* with <strong>text</strong>, and \n with <br>
    return value
      .replace(/\\n/g, '<br>')
      .replace(/\*\*(.*?)\*\*/g, '<h2>$1</h2>')
      .replace(/\*(.*?)\*/g, '<strong>$1</strong>');
  }

}